import React from 'react';
import { flow } from 'lodash';
import propTypes from 'prop-types';
import format from 'react-format-props';
import classNames from 'classnames';
import { SafeComponent } from '../../SafeComponent';
import { SHARED_LOG_MODULE } from '../../../RealtimeNotifications/shared/constants';
import './style.scss';

export function ProfilePicture({ username, imageUrl, online }) {
    const className = classNames('profile-picture', { online });
    return (
        <div className={className} title={username}>
            {username && <div className="user-initial font-accent">{username[0]}</div>}
            {imageUrl && <div style={{ backgroundImage: `url(${imageUrl})` }} className="user-image"></div>}
        </div>
    );
}

ProfilePicture.propTypes = {
    username: propTypes.string,
    imageUrl: propTypes.string,
    online: propTypes.bool,
};

ProfilePicture.defaultProps = {
    online: false,
};

/**
 * I am a filthy hack used for development. I will get deleted waaaayyyy before going to production.
 * They just need to sort some backend stuff out before they remove me.
 * If you see me here after this feature went live, please fire @ealush.
 */
const extractPictureFromHTML = (profilePicture) => {
    const div = document.createElement('div');
    div.innerHTML = profilePicture;
    const img = div.querySelector('img');

    if (!img) {
        return null;
    }
    return img.getAttribute('src');
};

export default flow(
    format(({ item } = {}) => ({
        username: item.username,
        online: item.online,
        imageUrl: extractPictureFromHTML(item.profilePicture),
    })),
    SafeComponent(SHARED_LOG_MODULE, 'ProfilePicture')
)(ProfilePicture);
